
import { Vue, Component } from 'vue-property-decorator'

@Component({
  name: 'NotificationIcon',
})
export default class NotificationIcon extends Vue {}
